import { lowerCase, startCase } from "lodash";
import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useFormContext, useFormState } from "react-hook-form";
import { DIGITAL_BROCHURE_SIZE_SKU } from "../../../helpers/printConstants";
import { usePrevious } from "../../../hooks";
import { Notes } from "../../fields";
import { BlockCheckbox } from "../../fields/BlockCheckbox";
import { InlineCheckbox } from "../../fields/InlineCheckbox";
import AddOnSection from "../AddOnSection";
import { DigitalTemplateSelect } from "./DigitalTemplateSelect";
import { PaperTemplateSelect } from "./PaperTemplateSelect";
import { usePrintTypeValues } from "./helpers";
export const PrintAgentOptions = () => {
  return (
    <>
      <Row>
        <BlockCheckbox sku="3001" />
        <BlockCheckbox sku="3006" />
        <BlockCheckbox sku="3004" />
      </Row>
      <Options show_skus={["3001"]} type="brochure" />
      <Options show_skus={["3006"]} type="digital_brochure" />
      <Options show_skus={["3004"]} type="rack_card" />
    </>
  );
};

const NoteTypeSelection = ({ sku, required }) => {
  const { getValues, resetField } = useFormContext();
  const handleClick = ({ target: { value } }) => {
    if (value && getValues(sku) === value) {
      resetField(sku);
    }
  };
  return (
    <Row>
      <Col xs="auto">
        <InlineCheckbox
          type="radio"
          sku={sku}
          controlId={`${sku}_missing_template`}
          value="Template Missing"
          label="I have a template on file that is missing"
          onClick={(e) => {
            handleClick(e, "Template Missing");
          }}
          required={required}
        />
      </Col>
      <Col xs="auto">
        <InlineCheckbox
          type="radio"
          sku={sku}
          controlId={`${sku}_new`}
          value="New Template Needed"
          label="I need something new"
          onClick={(e) => {
            handleClick(e, "New Template Needed");
          }}
          required={required}
        />
      </Col>
    </Row>
  );
};

const Options = ({ type, ...props }) => {
  const { clearErrors, setValue } = useFormContext();
  const { errors } = useFormState({ name: `print.${type}` });
  const { skus, note_type_sku, notes_sku, required } = usePrintTypeValues(type);
  const name = startCase(type);
  useEffect(() => {
    if (!required) clearErrors();
  }, [required, clearErrors]);
  return (
    <AddOnSection
      addon_skus={[
        ...skus,
        note_type_sku,
        notes_sku,
        DIGITAL_BROCHURE_SIZE_SKU,
      ]}
      title={`Your ${name} Template Sizes`}
      {...props}
    >
      {type !== "digital_brochure" ? (
        <PaperTemplateSelect type={type} />
      ) : (
        <DigitalTemplateSelect />
      )}
      <h2 className="mb-4">{`Other ${name} Options`}</h2>
      <NoteTypeSelection sku={note_type_sku} required={required} />
      <AddOnSection show_skus={[note_type_sku]} addon_skus={[notes_sku]}>
        <PrintNotes name={notes_sku} />
      </AddOnSection>
      {errors?.print?.[type] && (
        <div
          className="text-link mb-4"
          onClick={() => setValue(props.show_skus[0], false)}
        >
          {`I don't want a ${lowerCase(type)}`}
        </div>
      )}
    </AddOnSection>
  );
};

const PrintNotes = ({ name }) => {
  const { unregister } = useFormContext();
  const prevName = usePrevious(name);
  useEffect(() => {
    if (prevName !== name && prevName) {
      unregister(prevName);
    }
  }, [name, prevName, unregister]);
  return (
    <Row key={name}>
      <Col md={12}>
        <Notes
          name={name}
          label="Details"
          placeholder="New print setup may effect the estimated cost. Please let us know what you're looking for and we will contact you."
          required
        />
      </Col>
    </Row>
  );
};
